import React from "react"

import { Modal } from "react-bootstrap"

import Wrong from "../../images/icons/wdn-wrong.png"

import "./modal.scss"

const ModalComponent = props => {
  return (
    <Modal show={props.show}>
      <div className="modal-content__wrapper">
        <div
          className="modal-content-close"
          role="button"
          tabIndex={0}
          onKeyDown={() => props.setShow(false)}
          onClick={() => props.setShow(false)}
        >
          <img src={Wrong} alt="wdn-wrong" className="close-button" />
        </div>
        <div className="modal-children">{props.children}</div>
      </div>
    </Modal>
  )
}

export default ModalComponent
